export const subscriptionProductIdConstants = {
  preferredCustomer: '784f3fe8-b3d7-496a-bb23-78e6fe9d0b6e',
  preferredCustomerRenewal: '4e8a47bb-b4a0-4b3f-ba38-2f9149226b64',
  wineClub: 'e59cd67d-084f-48c4-b51f-3d20750e793f',
};

export const subscriptionPlanIdsConstants = {
  preferredCustomerPlanId: 'd6380648-9caf-4c1b-a569-d69a786aadde',
  wineClubPlanId: 'd4586aea-63ea-42e3-b31e-15e2102c8228',
  CEPlanId: '08c96d98-0ecc-4348-921d-033141e76dbb',
  CEMonthlyPlanId: '27ff8670-7189-4f8c-8224-c0934d3890fe',
  CEMonthly2PlanId: 'ac31bd0e-8a2b-47c9-8bd9-937c5ea7aeb8',
};

export const defaultCuratedPackName = 'wineclub';
